var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"in-stock",class:_vm.badgeInfo.class},[_c('div',{staticClass:"in-stock__text-wrap"},[_c('img',{attrs:{"src":_vm.badgeInfo.icon,"alt":"icon"}}),_c('span',[_vm._v(_vm._s(_vm.badgeInfo.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }